import { render, staticRenderFns } from "./CommandHistory.vue?vue&type=template&id=c54b12ee"
import script from "./CommandHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandHistory.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports